import React, { FC } from 'react';
import { shouldPioritizeComponentResources } from '../../utils/component.utils';
import Picture from '../@shared/picture';
import { TMediaImage } from './types/heroBanner.types';

const MediaImage: FC<TMediaImage> = (props) => {
  const { mobileHeroImage, desktopHeroImage, dataSource, placeholderData } = props;
  return (
    <Picture
      editorialImageProps={{
        mobileImage: mobileHeroImage,
        desktopImage: desktopHeroImage,
        desktopTransformation: 'Size1900',
        mobileTransformation: 'Size1000',
        id: dataSource,
        cssClassPictureEl: 'hero-banner__image hero-banner__image--strict-height',
        prioritize: shouldPioritizeComponentResources(placeholderData, 'SmallHero'),
      }}
    />
  );
};

export default MediaImage;
